import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import facetType from '../../../utility/types/facetType';
import { store } from '../../../redux/store';

class AlertTagsFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = facetType.ALERT_TAGS;
    this.displayName = 'Alert Tags';
    this.description = 'include...';
    this.state = store.getState();
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
      [OperatorTypes.EQUAL_TO_BOOLEAN]: 'ALL of the following:',
      [OperatorTypes.NOT_EQUAL_TO]: 'NONE of the following:',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  /* istanbul ignore next */
  getName() {
    return this.displayName;
  }

  getDescription() {
    return this.description;
  }

  getDisplayValue1(value) {
    const tags = this.state.tagList.tagList;
    const foundTag = tags.find((tag) => parseInt(tag.id, 10) === parseInt(value, 10));
    return foundTag ? foundTag.name : '';
  }

  /* istanbul ignore next */
  // eslint-disable-next-line class-methods-use-this
  getValueSelectOptions(tagList) {
    return tagList.map((tag) => ({ value: tag.id.toString(), label: tag.name }));
  }

  // eslint-disable-next-line class-methods-use-this
  /* istanbul ignore next */
  getTooltip(filtersByOperatorObj) {
    const { tagList } = this.state.tagList;
    return `Alert Tags are ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map((filter) => tagList.find((tag) => parseInt(filter.value1, 10) === parseInt(tag.id, 10)).name).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
        ? ` ALL of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
          .map((filter) => tagList.find((tag) => parseInt(filter.value1, 10) === parseInt(tag.id, 10)).name).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map((filter) => tagList.find((tag) => parseInt(filter.value1, 10) === parseInt(tag.id, 10)).name).join(', ')
        };`
        : ''
    }`;
  }
}
export default AlertTagsFacet;
